export const CHECKBOX_LABEL = "I agree to the terms and conditions.";
export const HYPERLINK_TEXT = "Click here for the terms & conditions.";
export const VIEW_LEGAL_TERMS = "view-legal-terms";
